import _ from 'lodash';
import React, {
  useState,
  useReducer,
  useEffect,
} from 'react';
import {
  Switch,
  TimePicker,
  Input,
  Button,
  OverlayTrigger,
  PopOver,
  Icon,
  RadioGroup,
} from '@tencent/spaui';
import '../../../../../style/less/pages/recycle.less';
import { RPCFactory } from '../../../../utils/RequestUtil';
import { beaconInstance } from '../../../../instrumentation/beaconSetup';
import { useSelector, useDispatch } from 'react-redux';
import RecycleAction from '../../../../actions/RecycleAction';
import DynamicInputGroup from '../../../common/DynamicInputGroup';
import RuleItem from './RuleItem';
import { LogicNewRelation } from "../../../helper/RuleApplyRangeHelper";
const ACTION = {
  RESET_DATA: 'RESET_DATA',
  SET_DATA: 'SET_DATA',
  SET_DATA_START: 'SET_DATA_START',
  SET_DATA_END: 'SET_DATA_END',
  STORE_DATA: 'STORE_DATA',
};

const GUIDE_URL = "https://leads.gdtimg.com/qzone/biz/gdt/leads-cdn/doc/leads_recycle_and_claim_helper.pdf"; // 线索自动回收规则指引链接

const timeList = (() => {
  const list = [];
  const getHour = n => `00${n}`.slice(-2);
  for (let i = 0; i < 24; i++) {
    list.push(`${getHour(i)}:00`);
    list.push(`${getHour(i)}:30`);
  }
  return list;
})();

const num2time = (n = 0) => {
  const prefix = num => `00${num}`.slice(-2);
  const hour = Math.floor(n / 60);
  const minutes = n % 60;
  return [hour, minutes].map(prefix).join(':');
};

const time2num = (time) => {
  const [hour, minute] = time.split(':');
  return parseInt(hour * 60) + parseInt(minute);
};

const Head = () => {
  const dispatch = useDispatch();
  const state = useSelector((s) => s.recycle);

  const handleSwitchChange = (e, value) => {
    const setStatus = (val) => dispatch({
      type: RecycleAction.UPDATE,
      payload: { enableClaim: val },
    });
    setStatus(value);
    const params = { claimingPauseStatus: value ? 0 : 1 };
    RPCFactory.leadsManage.setClaimStatus(params)
      .fail((ret, msg) => {
        alert(msg);
        setStatus(!value);
      });
  };

  const overlay = (
    <PopOver>
      <p>开启该按钮后，支持同一团队的客服经理及客服人员于线索公海池认领回收后待分配的线索。</p>
    </PopOver>
  );

  return (
    <div className="leads-recycle-head lh-card">
      <div className="leads-recycle-title">认领回收线索</div>
      <div className="leads-recycle-switch">
        <Switch
          checked={state.enableClaim}
          onChange={handleSwitchChange}
        />
        <OverlayTrigger
          overlay={overlay}
          placement="left"
          delay={100}
        >
          <i className="icon icon-help" />
        </OverlayTrigger>
        <span>开启认领</span>
      </div>
      <div className="text-weak">开启认领按钮后，支持客服经理及客服人员于线索公海池查看并认领从该团队其他员工回收后待分配的线索。（客服被回收的线索其本人无法再次认领）</div>
    </div>
  );
};

const defaultState = {
  data: {
    id: -1,
    starttime: '08:00',
    endtime: '18:00',
    dulltime: 3,
    action: '1',
    limit: 3,
  },
  dataCopy: {},
  option: {
    starttimeList: timeList,
    endtimeList: timeList,
    actions: [
      {
        label: '使用线索平台外呼',
        value: '1',
      },
      {
        label: '更新线索状态',
        value: '2',
      },
      {
        label: '更新线索标签',
        value: '3',
      },
      {
        label: '添加跟进记录',
        value: '4',
      },
      {
        label: '更新线索评分',
        value: '5',
      },
      {
        label: '判定线索质量',
        value: '6',
      },
      {
        label: '对未接通的线索拨打次数满3次',
        value: '7',
      },
    ],
  },
};

const reducer = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ACTION.RESET_DATA: {
      let { option } = state;
      const cover = payload || {};
      const data = { ...state.dataCopy, ...cover };
      if (payload) {
        const startIndex = timeList.indexOf(data.starttime);
        const endIndex = timeList.indexOf(data.endtime);
        let { endtimeList } = state.option;
        let { starttimeList } = state.option;
        if (endIndex !== -1) {
          starttimeList = timeList.slice(0, endIndex);
        }
        if (startIndex !== -1) {
          endtimeList = timeList.slice(startIndex + 1);
        }
        option = { ...state.option, endtimeList, starttimeList };
      }
      return { ...state, data, option };
    }
    case ACTION.SET_DATA: {
      const data = { ...state.data, ...payload };
      return { ...state, data };
    }
    case ACTION.SET_DATA_START: {
      const index = timeList.indexOf(payload);
      let { endtimeList } = state.option;
      if (index !== -1) {
        endtimeList = timeList.slice(index + 1);
      }
      const option = { ...state.option, endtimeList };
      const data = { ...state.data, starttime: payload };
      return { ...state, data, option };
    }
    case ACTION.SET_DATA_END: {
      const index = timeList.indexOf(payload);
      let { starttimeList } = state.option;
      if (index !== -1) {
        starttimeList = timeList.slice(0, index);
      }
      const option = { ...state.option, starttimeList };
      const data = { ...state.data, endtime: payload };
      return { ...state, data, option };
    }
    case ACTION.STORE_DATA: {
      const dataCopy = { ...state.data };
      return { ...state, dataCopy };
    }
    default:
      return state;
  }
};

const Body = () => {
  const reduxDispatch = useDispatch();
  const recycleState = useSelector((s) => s.recycle);
  const [isEditing, setIsEditing] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [state, dispatch] = useReducer(reducer, defaultState);
  const { data, option } = state;
  // 规则 by fightingliu
  data.logicRuleRelation = recycleState.enableRuleRelationship? 'AND': 'OR';

  const handleStartChange = (e, value) => {
    dispatch({
      type: ACTION.SET_DATA_START,
      payload: value,
    });
  };

  const handleEndChange = (e, value) => {
    dispatch({
      type: ACTION.SET_DATA_END,
      payload: value,
    });
  };

  const handleSwitchChange = (e, value) => {
    const setStatus = (val) => reduxDispatch({
      type: RecycleAction.UPDATE,
      payload: { enableAutoRecycle: val },
    });
    setStatus(value);
    const params = { autoReclaimingPauseStatus: value ? 0 : 1 };
    RPCFactory.leadsManage.setRecycleStatus(params)
      .fail((ret, msg) => {
        alert(msg);
        setStatus(!value);
      });
  };

  // 多条规则关系 by fightingliu
  const handleRuleRelationChange = (e, value) => {
    dispatch({
      type: ACTION.SET_DATA,
      payload: { logicRuleRelation: value },
    });
    const setStatus = (val) => reduxDispatch({
      type: RecycleAction.UPDATE,
      payload: { enableRuleRelationship: val === 'AND' },
    });
    setStatus(value);
    const params = { reclaimRuleRelationship: value === 'AND' ? 0: 1 };
    RPCFactory.leadsManage.setRecycleStatus(params)
    .fail((ret, msg) => {
      alert(msg);
      setStatus('OR');
    });
  };

  const handleLimitChange = (e, limit) => {
    if (!/^\d*$/.test(limit)) return;
    dispatch({
      type: ACTION.SET_DATA,
      payload: { limit },
    });
  };

  const handleEdit = () => {
    dispatch({ type: ACTION.STORE_DATA });
    setIsEditing(true);
  };

  const handleCancelEdit = () => {
    dispatch({ type: ACTION.RESET_DATA });
    setIsEditing(false);
  };

  const handleSubmit = () => {
    dispatch({ type: ACTION.STORE_DATA });
    setSubmitting(true);

    const params = {
      workingHourStart: time2num(data.starttime),
      workingHourEnd: time2num(data.endtime),
      individualReclaimUpperBound: parseInt(data.limit) || 3,
    };

    if (!_.isEmpty(data?.reclaimRules)) {
      params.reclaimRules = _.map(data?.reclaimRules, ({ dulltime = '', action = '' }) => ({
        leadReclaimInterval: dulltime,
        reclaimCheckCondition: parseInt(action, 10),
      }));
    }


    let submitFn = RPCFactory.leadsManage.createRecycleRule;

    if (data.id !== -1) {
      params.id = data.id;
      submitFn = RPCFactory.leadsManage.updateRecycleRule;
    }

    submitFn(params)
      .done(({ id }) => {
        dispatch({
          type: ACTION.SET_DATA,
          payload: { id },
        });
        setIsEditing(false);
      })
      .fail((ret, msg) => {
        alert(msg || ret);
      })
      .always(() => {
        setSubmitting(false);
      });
  };

  useEffect(() => {
    beaconInstance.onUserAction(
      'page_view',
      { page: '线索回收' },
    );
  }, []);

  useEffect(() => {
    RPCFactory.leadsManage.getRecycleRule()
      .done((res) => {
        const reclaimRules = _.isEmpty(res.reclaimRules)? [] : _.map(res.reclaimRules,
          ({ leadReclaimInterval: dulltime = '', reclaimCheckCondition: action='' }) =>
            ({ dulltime, action })
        );
        const data = {
          id: res.id,
          starttime: num2time(res.workingHourStart),
          endtime: num2time(res.workingHourEnd),
          reclaimRules,
          limit: res.individualReclaimUpperBound,
        };
        dispatch({
          type: ACTION.RESET_DATA,
          payload: data,
        });
      });
  }, [dispatch]);

  const selectedReclaimList = _.map(data?.reclaimRules, ({ action = '' }) => `${action}`);
  const actionOptions = _.map(option.actions, ({ label = '', value = '' }) => ({
    label,
    value,
    disabled: _.includes(selectedReclaimList, value)
  }));
  // add by fightingliu
  const ruleItemProps = {
    // 默认组件选中值
    defaultItemValue: {
      dulltime: 1,
      // action: 1,
    },
    inputComponent: RuleItem,
    inputComponentProps: {
      isEditing,
      // 已选中的不能重复再选
      actionOptions,
    },
    hideAddBtn: !isEditing || !_.every(selectedReclaimList, o => !_.isEmpty(o)) // 不能有空选项
      || _.every(actionOptions, ['disabled', true]), // 选项用完了就不可再添加
    hideDelBtn: !isEditing, // 是否展示删除按钮
    addButtonPosition: 'bottom',
    addButtonText: '添加规则',
    // 组件传入的默认值
    value: data?.reclaimRules,
    onChange: (value) => {
      // 非编辑状态不重新设置数据
      if(isEditing){
        // 组件返回的参数
        dispatch({
          type: ACTION.SET_DATA,
          payload: { reclaimRules: value },
        });
      }
    }
  }

  return (
    <div className="leads-recycle-head lh-card">
      <div style={{
        display: 'flex',
        alignItems: 'center'
      }}>
        <div className="leads-recycle-title">线索自动回收规则</div>
        <a className="leads-recycle-guide"
           href={GUIDE_URL}
           target="_blank"
           rel="noopener noreferrer"
        >
          查看指引
        </a>
      </div>
      {
        !isEditing && (
          <div className="leads-recycle-switch">
            <span className="edit-btn" onClick={handleEdit}>编辑</span>
            <Switch
              checked={recycleState.enableAutoRecycle}
              onChange={handleSwitchChange}
            />
            <span>{recycleState.enableAutoRecycle ? '正在应用' : '未应用'}</span>
          </div>
        )
      }
      <div className="leads-recycle-box">
        <div className="leads-recycle-tips">开启自动回收时，您也可以在线索列表中手动回收</div>
        <div className="leads-recycle-line">
          <div className="leads-recycle-label">
            <span>工作时间段</span>
            <OverlayTrigger
              trigger="hover"
              delay={100}
              placement="top"
              overlay={(
                <PopOver>
                  <span>自动回收规则中的时间计算仅包含工作时间段</span>
                </PopOver>
              )}
            >
              <i className="icon icon-help" />
            </OverlayTrigger>
          </div>
          <div className="leads-recycle-content">
            <TimePicker
              timeList={option.starttimeList}
              value={data.starttime}
              onChange={handleStartChange}
              style={{ width: 90 }}
              disabled={!isEditing}
              data-testid="start"
            />
            <span style={{ margin: '0 12px' }}>至</span>
            <TimePicker
              timeList={option.endtimeList}
              value={data.endtime}
              onChange={handleEndChange}
              style={{ width: 90 }}
              disabled={!isEditing}
              data-testid="end"
            />
          </div>
        </div>
        <div className="leads-recycle-line" style={{ alignItems: 'baseline' }}>
          <div className="leads-recycle-label">
            <span>回收规则</span>
            <OverlayTrigger
              trigger="hover"
              delay={100}
              placement="top"
              overlay={(
                <PopOver>
                  <span>广告主可自定义规则条件，其中“判定线索质量”指的是客服修改线索状态且线索状态不等于待判定</span>
                </PopOver>
              )}
            >
              <i className="icon icon-help" />
            </OverlayTrigger>
          </div>
          <div className="leads-recycle-content wrapper">
            {_.size(data?.reclaimRules) > 1 && <div
              className="leads-recycle-content-sub">
              <span style={{ marginRight: 24 }}>多条规则间关系</span>
              <RadioGroup
                disabled={!isEditing}
                data={Object.keys(LogicNewRelation).map((key) => ({
                  value: key,
                  children: LogicNewRelation[key],
                }))}
                value={data?.logicRuleRelation}
                onChange={handleRuleRelationChange}
              />
            </div>
            }
            <div style={{ marginLeft: 6 }}>
              {isEditing && <div className="leads-recycle-content-sub">
                <Icon name="info-filled" width={14} height={14} color='#C4C7CC'/>
                <span
                  className="notice">若需客服多个规则均执行线索才不回收，规则关系请选“且”（对客服要求更严格）；若执行任意规则线索即可不回收，规则关系请选“或”（对客服要求更宽松 ）。</span>
              </div>
              }
              <DynamicInputGroup
                {...ruleItemProps}
              />
            </div>
          </div>
        </div>
        <div className="leads-recycle-line" style={{ alignItems: 'baseline' }}>
          <div className="leads-recycle-label">
            <span>回收通知设置</span>
          </div>
          <div className="leads-recycle-content wrapper">
            <div className="leads-recycle-content-sub">
              <span>1. 线索回收前15分钟，系统将通过短信触发提醒线索归属人线索即将被回收；</span>
              <OverlayTrigger
                placement="top"
                delay={100}
                overlay={(
                  <PopOver>
                    <span>【腾讯科技】您有线索即将超时回收，为避免线索流失请尽快登录腾讯线索管理平台进行跟进。</span>
                  </PopOver>
                )}
              >
                <a href="#" onClick={e => e.preventDefault()}>提醒示例</a>
              </OverlayTrigger>
            </div>
            <div className="leads-recycle-content-sub">
              <span>2. 员工当日线索回收数量超过</span>
              <Input
                type="number"
                value={data.limit}
                onChange={handleLimitChange}
                style={{ width: 80 }}
                disabled={!isEditing}
                data-testid="limit"
              />
              <span>条时，微信提醒管理员和客服经理。</span>
            </div>
          </div>
        </div>
      </div>
      {
        isEditing && (
          <div className="leads-recycle-footer">
            <Button onClick={handleCancelEdit}>取消</Button>
            <Button
              displayType="primary"
              disabled={submitting}
              onClick={handleSubmit}
            >
              保存设置
            </Button>
          </div>
        )
      }
    </div>
  );
};

const Recycle = () => (
  <div className="leads-recycle">
    <Head />
    <Body />
  </div>
);

export default Recycle;
